import { render, staticRenderFns } from "./ContentContact.vue?vue&type=template&id=fe0515a0"
import script from "./ContentContact.vue?vue&type=script&lang=js"
export * from "./ContentContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports